'use client';

import { PropsWithChildren } from 'react';

import Right from './Right';

const Header = ({ children }: PropsWithChildren) => {
	return <div>{children}</div>;
};

Header.Right = Right;

export default Header;
